import React from 'react'
import HeroSection from '../../components/About/HeroSection'
import WhoWeAre from '../../components/About/WhoWeAre'
import MissionVisionSection from '../../components/About/MissionVisionSection'
import FadeInSectionDownToUp from '../../components/FadeAnimations/FadeInSectionDownToUp'

export default function AboutUs() {
    return (
        <div>
            <div>
                <HeroSection />
            </div>
            <div>
                <WhoWeAre />
            </div>
            <div>
                <MissionVisionSection />
            </div>
            <div>
                <FadeInSectionDownToUp>
                    <img className='w-full' src='https://mhcockpit.com/Media/4%20Aviators/About/team.png' alt='Our Team' />
                </FadeInSectionDownToUp>
            </div>
            <div>
                <div className="px-10">
                    <section
                        className="relative w-full bg-cover bg-center bg-no-repeat h-[600px] flex items-center justify-start rounded-3xl"
                        style={{
                            backgroundImage:
                                "url('https://mhcockpit.com/Media/4%20Aviators/About/Enroll.jpg')",
                        }}
                    >
                        {/* Optional dark overlay for better text visibility */}
                        {/* <div className="absolute inset-0 bg-black bg-opacity-50 rounded-3xl"></div> */}

                        {/* Content */}
                        <div className="relative z-10 text-left text-white px-10">
                            <h2 className="text-3xl sm:text-4xl md:text-5xl font-semibold mb-4">
                                Hurry Up !!! Your Time to Fly is <br /> Now: Enroll at <span className='text-[#FD9F27]'>4 Aviators</span>.
                            </h2>
                            <a href="/contact-us" className="bg-[#012D6F] hover:bg-[#023a8a] text-white px-8 py-3 rounded-full font-semibold transition-all duration-300">
                                Register
                            </a>
                        </div>
                    </section>
                </div>
            </div>
        </div>
    )
}
